
import React from "react";
import { useNavigate } from "react-router-dom";
import temporal from "../../../assets/images&icons/bg-login.jpg";

export interface IPressCard {
  id: string;
  legacyId: string;
  title: string;
  content?: string;
  summary?: string;
  publishedDate: string;
  authorName?: string;
  authorTitle?: string;
  authorLastName?: string;
  imageUrl?: string;
}

interface IPress {
  data: IPressCard[];
}

const Press: React.FC<IPress> = ({ data }) => {
  const navigate = useNavigate();

  if (!data || data.length === 0) {
    return (  
      <div className="flex flex-col gap-4 text-gray-font justify-center items-center h-full">
        <div className="text-center py-4 font-sans text-[#474F56] text-base font-semibold leading-normal overflow-hidden text-ellipsis" style={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 3,
          alignSelf: 'stretch'
        }}>
          You haven't uploaded any press releases yet.<br />
          Grow your influence adding one today.
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full">
      {/* Image on the left */}
      <div
        className="w-1/3 bg-cover bg-center rounded-md flex-shrink-0 hidden md:flex"
        style={{ backgroundImage: `url(${temporal})` }}
      />
      
      <div className="w-px bg-gray-100 mx-4 hidden md:block"/>
      
      <div className="flex flex-col gap-4 w-full md:w-2/3">
        {data.map((press, index) => (
          <div className="w-full" key={index}>
            <button
              className="text-left w-full"
              onClick={() => navigate(`/releases.asp?action=press&pressid=${press.legacyId}`)}
            >
              <div className="text-Default text-base leading-tight mb-1 hover:underline cursor-pointer">
                {press.title}
              </div>
            </button>
            <div className="text-gray-600 text-sm underline cursor-pointer">
              {press.authorName}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Press;
